import * as aiAssistantService from '../../../services/AiAssistant/aiAssistantService';
import {api as messageDialogAPI, api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import Network from 'infrastructure/js/modules/network';
import { aiAgentPreferencesKeys } from '../../../enums/aiAgentPreferencesKeys';
import { api as loginActions } from '../../Login/loginActions';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_IN_PROGRESS: 'ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_IN_PROGRESS',
  ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_FINISHED: 'ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_FINISHED',
  ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_FAILED: 'ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_FAILED',
  ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_FETCH_DATA_IN_PROGRESS: 'ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_FETCH_DATA_IN_PROGRESS',
  ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_FETCH_DATA_FINISHED: 'ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_FETCH_DATA_FINISHED',
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  submitInProgress: function (payload) {
    return { type: actionTypes.ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_IN_PROGRESS, payload: payload };
  },
  submitFinished: function (payload) {
    return { type: actionTypes.ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_FINISHED, payload: payload };
  },
  submitFailed: function (payload) {
    return { type: actionTypes.ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_SUBMIT_FAILED, payload: payload };
  },
  fetchDataInProgress: function (payload) {
    return { type: actionTypes.ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_FETCH_DATA_IN_PROGRESS, payload: payload };
  },
  fetchDataFinished: function (payload) {
    return { type: actionTypes.ADMINISTRATION_SETTINGS_AI_AGENT_PREFERENCES_VIEW_FETCH_DATA_FINISHED, payload: payload };
  },
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function () {
  return function (dispatch, getState) {
    return api.fetchData(dispatch, getState)();
  };
};

jsxActions.submit = function (data, messageDialogBuilder) {
  return function (dispatch, getState) {
    return api.submit(dispatch, getState)(data, messageDialogBuilder);
  };
};


/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.fetchData = function (dispatch, getState) {
  return function () {
    dispatch(actions.fetchDataInProgress());

    return aiAssistantService.fetchAiAgentPreferences()
      .then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('fetch AI Agent preferences failed.');
          messageDialogApi.responseError(dispatch, getState)(response);
          dispatch(actions.fetchDataFinished());
          return;
        }

        const aiAgentpreferences = response?.data?.preferences;

        const data = {
          memory: aiAgentpreferences[aiAgentPreferencesKeys.MEMORY],
        };

        dispatch(actions.fetchDataFinished(data));

        return data;
      })
      .catch(() => {
        dispatch(actions.fetchDataFinished());
        console.error('fetch AI Agent preferences failed.');
      });
  };
};

api.submit = function (dispatch, getState) {
  return async function (data) {
    dispatch(actions.submitInProgress());

    try {
      const response = await aiAssistantService.setAiAgentPreferences(data);

      if (!Network.isResponseValid(response)) {
        console.error('Submit AI Agent preferences failed');
        messageDialogApi.responseError(dispatch, getState)(response);
        return;
      }

      messageDialogApi.showSuccess(dispatch, getState)('');
      loginActions.updateLoggedInUserOrgPreferences()(dispatch, getState);

    } catch (e) {
      console.error('Submit AI Agent preferences failed.');
    }

    dispatch(actions.submitFinished());
    return api.fetchData(dispatch, getState)();
  };
};


////////////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS
// function _getMessageDialogBuilder(responses) {
//   let dialogLabels = createLabelHelper('mat.administration.settings.schedulingPreferences.view.alert.');
//
//   const messages = [dialogLabels.get('error.goals'), dialogLabels.get('error.preferences'), dialogLabels.get('error.rules')];
//
//   const children = responses.reduce((accumulatedChildren, currentResponse, i) => {
//     if (!Network.isResponseValid(currentResponse)) {
//       accumulatedChildren.push(<MessageDialog.MessageRow key={i} text={messages[i]} />);
//     }
//     return accumulatedChildren;
//   }, []);
//
//   return { title: dialogLabels.get('error'), type: 'error', className: 'oneBackground', children };
// }
